
export function scrollTo(el, offset = -200) {
	
	const supportsSmooth = 'scrollBehavior' in document.documentElement.style
	const y = el.getBoundingClientRect().top + window.pageYOffset + offset
	const x = el.getBoundingClientRect().left + window.pageXOffset

	if (supportsSmooth) {
		window.scroll({ behavior: 'smooth', left: x, top: y })
	} else {
		window.scroll(x, y)
	}	
}